/**
 * 예외 하나 → 사람이 아니라 **개발자가 읽을** 한 덩이 글.
 *
 * 🔴 **화면 본문에는 안 쓴다.** 접힌 `<details>` 안과 `console.error` 에만 들어간다 —
 *    영문 스택은 사람이 할 일을 알려 주지 않는다.
 * ⚠ 던져진 것이 `Error` 라는 보장이 없다(문자열 · 객체 · `undefined` 전부 온다).
 * ⚠ 컴포넌트 파일과 갈라 둔 것은 핫리로드 때문이다(`react-refresh/only-export-components`).
 */
export function errorText(error: unknown): string | null {
  if (error instanceof Error) {
    return error.stack ?? `${error.name}: ${error.message}`
  }
  if (typeof error === 'string') return error === '' ? null : error
  if (error === null || error === undefined) return null
  try {
    return JSON.stringify(error) ?? null
  } catch {
    // 순환 참조 등. 🔴 `String(error)` 은 쓰지 않는다 — 대부분 `[object Object]` 로 끝난다
    return Object.prototype.toString.call(error)
  }
}
